import { get, post, put } from 'utils/methods';

export function getEmailTemplateApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}email_templates`, data, headers);
}

export function getEmailTemplateTagsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}email-template-tags`, data, headers);
}

export function addEmailTemplateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/email_template`, data, headers);
}

export function editEmailTemplateApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/email_template`, data, headers);
}
